import React, { ReactPropTypes, ReactElement } from 'react';
import { connect } from 'react-redux';

interface Props extends Partial<ReactPropTypes> {
  feature: string;
  children: ReactElement;
  features?: string[];
}

function Feature({ feature, features, ...rest }: Props) {
  return <>{features && features.includes(feature) && rest['children']}</>;
}

function mapStateToProps(state) {
  return { features: state.app.features };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Feature);
